"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENotificationChannel = void 0;
var ENotificationChannel;
(function (ENotificationChannel) {
    ENotificationChannel["geral"] = "Geral";
    ENotificationChannel["conversas"] = "Conversas";
    ENotificationChannel["financeiro"] = "Financeiro";
    ENotificationChannel["academico"] = "Acad\u00EAmico";
})(ENotificationChannel = exports.ENotificationChannel || (exports.ENotificationChannel = {}));
